<template>
    <!-- consult -->
    <div class="consult-wrapper">
      <div class="cndns-right-menu">
        <!-- <div class="cndns-right-item fw business">
            <div class="cndns-right-btn" rel="nofollow">
                <span class="icon-icon_icon-2 icon-icon_icon-01"></span>
                <p class="wz">售前咨询</p>
            </div>
            <div class="cndns-right-box" style="top: -30px; display: none;">
                <div class="box-border">
                    <p class="wz1">咨询热线</p>
                    <p class="wz2">400-800-5571</p>
                </div>
            </div>
        </div>
        <div class="cndns-right-item fw technology">
            <div class="cndns-right-btn" rel="nofollow">
                <span class="icon-icon_icon-2 icon-icon_icon-02"></span>
                <p class="wz">售后咨询</p>
            </div>
            <div class="cndns-right-box" style="top: -34px; display: none;">
                <div class="box-border">
                    <p class="wz1">服务热线</p>
                    <p class="wz2">15345810586</p>
                </div>
            </div>
        </div> -->

        <!-- <div class="cndns-right-item fw technology">
            <div class="cndns-right-btn" rel="nofollow">
                <span class="icon-icon_icon-2 icon-icon_icon-04"></span>
                <p class="wz">咨询电话</p>
            </div>
            <div class="cndns-right-box" style="top: -34px; display: none;">
                <div class="box-border">
                    <p class="wz1">咨询热线</p>
                    <p class="wz2">153-4581-0586</p>
                </div>
            </div>
        </div> -->

        <div class="cndns-right-item fw complaint" @click="toBuy">
            <div target="_blank" class="cndns-right-btn" rel="nofollow">
                <span class="icon-icon_icon-2 icon-icon_icon-03"></span>
                <p class="wz">点击购买</p>
            </div>
        </div>
      </div>
      <pcPayment @payClose="payShow = false" :payModal="payShow"></pcPayment>
    </div>
    
    
</template>

<script>
import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'
import pcPayment from '../components/pcPayment.vue'

import {
  getPayQrCode,
  getUserPayOrderStatus,
} from '@/api/api'

export default {
  name: 'consult',
  components: {
    pcPayment
  },
  computed: {
    ...mapGetters(['token'])
  },
  data () {
    return {
      payShow: false,
      buyType: 10, // 10支付宝11微信
      buyTltle: '请使用支付宝APP扫码完成支付',
      orderObj: {},
      timer:null,
    }
  },
  mounted() {
      $(".cndns-right-item.fw").mouseover(function () {
        $(this).find('.cndns-right-box').show();
      }).mouseout(function () {
          $(this).find('.cndns-right-box').hide();
      });
  },
  methods: {
    toBuy(){
      //this.payShow = true;
      if (this.token) {
        this.payShow = true;
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    },
    closeBtn () {
      clearInterval(this.timer)
      this.payShow = false
    },
    choice (type) {
      this.buyType = type
      if (type == 10) {
        this.buyTltle = '请使用支付宝APP扫码完成支付'
      } else {
        this.buyTltle = '请使用微信APP扫码完成支付'
      }
      this.getPayCode()
    },
    getPayCode () {
      clearInterval(this.timer)
      let data = {
        type: this.buyType
      }
      getPayQrCode(data).then(res => {
        if (res.status == 200) {
          // this.$message.success("注册成功")
          this.orderObj = res.body;
          this.getUserPayOrderStatus()
          
        }
      })
    },
    getUserPayOrderStatus(){
      this.timer = setInterval(()=>{
        let params = {
          orderNo: this.orderObj.orderNo
        }
        getUserPayOrderStatus(params).then(res => {
          if (res.status == 200) {
            if(res.body){
              this.payShow = false;
              this.$message.success("支付成功")
              clearInterval(this.timer)
            }
          }
        })
      },2000) 
    },
  },
  beforeDestroy(){
    clearInterval(this.timer)
  }
}


</script>


<style lang="scss" scoped>
.cndns-right-menu {
    position: fixed;
    right: 2px;
    // top: 48%;
    top: 60%;
    z-index: 100;
    width: 64px;
    // height: 282px;
    // height: 188px;
    height: 98px;
    border-radius: 20px;
    box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 1);
    background: #ffffff;
    margin-top: -100px;
}
.cndns-right-menu .cndns-right-item {
    position: relative;
    cursor: pointer;
    margin: 14px 0 14px 0;
}

.cndns-right-menu .active {
    background: linear-gradient(90deg, #00B8FE 0%, #0082FC 100%);
    border-radius: 8px;
}

.cndns-right-menu .active {
    background: linear-gradient(90deg, #00B8FE 0%, #0082FC 100%);
    border-radius: 8px;
}

/* .cndns-right-item:hover i {
    color: #0069EA !important;
}

.cndns-right-item:hover .wz {
    color: #0069EA !important;
} */

.item01 img {
    display: none !important;
}

.item01 .active01 {
    display: inline !important;
}

.cndns-right-menu .current {
    color: #FFFFFF !important;
}

.cndns-right-menu .cndns-right-btn {
    width: 64px;
    height: 76px;
    overflow: hidden;
    padding: 0;
    text-align: center;
    display: block;
    position: relative;
}

.cndns-right-menu .cndns-right-btn .iconfont {
    color: rgb(51, 51, 51);
}

.cndns-right-menu .cndns-right-box {
    position: absolute;
    top: -5px;
    right: 48px;
    padding-right: 50px;
    display: none;
}

.cndns-right-menu .box-border {
    width: 188px;
    // height: 156px;
    overflow: hidden;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px #CEDDF2;
    border-radius: 8px;
    padding: 20px;
    padding-bottom: 0px;
}

.cndns-right-menu .cndns-right-item .wz1 {
    margin: 0;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgb(0, 105, 234);
    line-height: 22px;
}

.cndns-right-menu .cndns-right-item .wz2 {
  	display: inline-block;
    margin-bottom: 24px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #05172E;
    line-height: 22px;
}

.cndns-right-menu .cndns-right-item .wz {
    width: 28px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgb(51, 51, 51);
    line-height: 20px;
    margin-left: 18px;
    margin-top: 0px;
}


.cndns-right-menu hr {
    margin: 0;
    border-color: #CEDDF2;
}

.icon-icon_icon-2{
  display: inline-block;
  width: 24px;
  height: 24px;
  
}
.icon-icon_icon-01{
  background: url('../assets/images/home_pre.png') no-repeat;
  background-size: cover;
}
.icon-icon_icon-02{
  background: url('../assets/images/home_after.png') no-repeat;
  background-size: cover;
}
.icon-icon_icon-03{
  background: url('../assets/images/home_buy.png') no-repeat;
  background-size: cover;
}
.icon-icon_icon-04{
  background: url('../assets/images/home_phone.png') no-repeat;
  background-size: cover;
}
//  移动端
@media screen and (min-width: 300px) and (max-width: 760px) {
    .cndns-right-menu {
        display: none;
    }
}
</style>


